import './assets/index.css'
import im from './im'
import { getQueryParam, getConfig, getUserInfo } from '@/api'

const app = window.layui.config({
  base: `${import.meta.env.BASE_URL}layim/layim-assets/lib/`,
  layimAssetsPath: `${import.meta.env.BASE_URL}layim/layim-assets/`, // layim 资源文件所在目录
  version: '20220119' // 改了源码需要设置版本号更新浏览器缓存
}).extend({
  'layer-mobile': 'layer-mobile',
  'zepto': 'zepto',
  'upload-mobile': 'upload-mobile',
  'layim-mobile': 'layim-mobile'
}).use(['layer-mobile', 'layim-mobile'], (layer, layim) => {
  // 提示层
  layer.msg = function(content) {
    return layer.open({
      content: content,
      skin: 'msg',
      time: 2 // 2秒后自动关闭
    })
  }

  const sesskey = getQueryParam('sesskey')
  const userid = getQueryParam('userid')
  Promise.all([
    getUserInfo({ 'sesskey': sesskey, 'userid': userid }),
    getConfig()
  ])
    .then(([userInfoRes, configRes]) => {
      const userInfo = userInfoRes?.data ?? {}
      const config = configRes?.data ?? {}
      layim.cache().mine = {
        id: Number(userInfo.mid),
        username: userInfo.username,
        nick: userInfo.nick,
        avatar: userInfo.avatar
      }
      layim.cache().socketUrl = config.socketUrl
      layim.cache().uploadImageUrl = config.uploadImageUrl
      layim.cache().sesskey = userInfo.sesskey
      im.install(app)
    })
})
